// Import logos
import intrnautsAiLogo from '../assets/logos/intrnauts-ai-logo.svg';
import intrnautsAiFavicon from '../assets/logos/intrnauts-ai-favicon.svg';
import intrnautsNetLogo from '../assets/logos/intrnauts-net-logo.png';
import intrnautsNetFavicon from '../assets/logos/intrnauts-net-logo-sq.png';
import intrnautsIoLogo from '../assets/logos/intrnauts-io-logo.svg';
import intrnautsDevLogo from '../assets/logos/intrnauts-dev-logo.svg';

export interface DomainConfig {
  id: string;
  name: string;
  fullName: string;
  tagline: string;
  hasBlog: boolean;
  primaryColor: string;
  secondaryColor: string;
  logoPath?: string;
  faviconPath?: string;
  fontFamily?: string;
}

export const DOMAIN_CONFIGS: Record<string, DomainConfig> = {
  net: {
    id: 'net',
    name: 'intrnauts.net',
    fullName: 'intrnauts Network',
    tagline: 'Your Gateway to Innovation',
    hasBlog: false,
    primaryColor: '#0a2342',
    secondaryColor: '#1e3f66',
    logoPath: intrnautsNetLogo,
    faviconPath: intrnautsNetFavicon,
    fontFamily: '"Inter", system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
  },
  ai: {
    id: 'ai',
    name: 'intrnauts.ai',
    fullName: 'intrnauts AI',
    tagline: 'navigating intelligent solutions',
    hasBlog: false,
    primaryColor: '#0a2342',
    secondaryColor: '#1e3f66',
    logoPath: intrnautsAiLogo,
    faviconPath: intrnautsAiFavicon,
    fontFamily: '"Space Grotesk", system-ui, -apple-system, sans-serif',
  },
  io: {
    id: 'io',
    name: 'intrnauts.io',
    fullName: 'intrnauts IO',
    tagline: 'Building Connected Systems',
    hasBlog: false,
    primaryColor: '#059669',
    secondaryColor: '#047857',
    logoPath: intrnautsIoLogo,
    fontFamily: '"IBM Plex Sans", system-ui, -apple-system, sans-serif',
  },
  dev: {
    id: 'dev',
    name: 'intrnauts.dev',
    fullName: 'intrnauts Development',
    tagline: 'A Developer\'s Journey',
    hasBlog: true,
    primaryColor: '#dc2626',
    secondaryColor: '#b91c1c',
    logoPath: intrnautsDevLogo,
    fontFamily: '"Geist", system-ui, -apple-system, sans-serif',
  },
  manzoorulhassan: {
    id: 'manzoorulhassan',
    name: 'manzoorulhassan.ai',
    fullName: 'Manzoorul Hassan',
    tagline: 'Three Decades of Software Innovation',
    hasBlog: true,
    primaryColor: '#1e40af',
    secondaryColor: '#1e3a8a',
    fontFamily: '"Source Serif 4", "Source Serif Pro", Georgia, "Times New Roman", serif',
  },
};

export const getCurrentDomain = (): DomainConfig => {
  const domain = process.env.REACT_APP_DOMAIN || 'dev';
  return DOMAIN_CONFIGS[domain] || DOMAIN_CONFIGS.dev;
};

export const getApiUrl = (): string => {
  return process.env.REACT_APP_API_URL || 'http://localhost:8000';
};
